import { Outlet } from "react-router-dom";
import { I18nProvider } from "./I18nProvider";
import { Toaster } from "../ui/sonner";

export const Providers = () => (
  <I18nProvider>
    <Outlet />
    <Toaster position="top-center" />
  </I18nProvider>
);
